module.exports = __webpack_public_path__ + "img/espresso_martini.fcacdef8.jpg";